import {atom} from 'recoil';

export const defaultValue = {
    visible: null,
    title: null,
    content: null,
    moveCancelAndConfirm: null,
    cancel: {label: null, click: null},
    confirm: {label: null, click: null},
    icon: null
}

const dialogAtom = atom({
    key: 'dialog',
    default: defaultValue
});

export {dialogAtom};
